/**
 * @generated SignedSource<<8f149ddf7f9f29de8adfee5caf704f2d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpSharedDibsPromiseModalLazy_user$data = {
  readonly " $fragmentSpreads": FragmentRefs<"PdpSharedDibsPromiseModal_user">;
  readonly " $fragmentType": "PdpSharedDibsPromiseModalLazy_user";
};
export type PdpSharedDibsPromiseModalLazy_user$key = {
  readonly " $data"?: PdpSharedDibsPromiseModalLazy_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpSharedDibsPromiseModalLazy_user">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpSharedDibsPromiseModalLazy_user",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedDibsPromiseModal_user"
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "fb724e0dcf76dcb977387eb46df990fd";

export default node;
